import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_AUTH, SKW_PREFIX } from '../../../utils/constants';
import { dashSlaRequest, dashSlaSucccess, dashSlaFailure } from './actions';

export function* loadDashSla({ payload }: ReturnType<typeof dashSlaRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}resumoAtendimentos&accessKey=${SKW_AUTH}&token=${state.auth.token}`,
      {
        dataInicial: payload.dataInicial,
        dataFinal: payload.dataFinal,
        cd: payload.cd,
        inscricao: payload.inscricao,
      }
    );

    yield put(dashSlaSucccess(response.data));
  } catch (error: any) {
    yield put(dashSlaFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar os dashboards do SLA, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
